(($) => {

    'use strict'

    const $form = $('#livestream-edit');
    if ($form.length === 0) {
        return;
    }

    $('.copy_link').click(function(e) {
        const data = e.target.dataset.url;
        navigator.clipboard.writeText(data);
    });

    const $roomSelector = $('#room-id');
    const ajaxUrl = $roomSelector.data('ajax-url');
    $roomSelector.change(function () {
        const roomId = $roomSelector.find('optgroup option:selected').val();
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                roomId: roomId,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',
            success: response => {
                $('#location').val(response)

            }
        });
    });
})($);
